/* unplugin-vue-components disabled */import script from "./v-nav-bar.vue?vue&type=script&setup=true&lang=js"
export * from "./v-nav-bar.vue?vue&type=script&setup=true&lang=js"

import "./v-nav-bar.vue?vue&type=style&index=0&id=d3d604b0&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d3d604b0"]])

export default __exports__